var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakeawayBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 37,
    viewBox: "0 0 44 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6953 34.2675H42.9996V19.4824H35.6953V34.2675Z",
    stroke: "#273135",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6955 31.6107C16.5217 38.0792 22.913 38.0792 1 26.9904C2.94112 25.0258 4.4732 24.5638 6.47824 25.1422L14.3614 27.6686",
    stroke: "#273135",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6957 21.332H30.2175C25.9225 21.332 22.9131 25.0283 22.0001 25.0283H15.6088C13.7827 25.0283 13.7827 28.7246 15.6088 28.7246H25.6523",
    stroke: "#273135",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0427 21.3294V1H6.47754V25.1421",
    stroke: "#273135",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7832 1V15.7851L19.2614 11.2423L24.7397 15.7851V1",
    stroke: "#273135",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeawayBlack);
export default __webpack_public_path__ + "static/media/takeawayBlack.66ea5811d0c283881c993e19ca48cbf9.svg";
export { ForwardRef as ReactComponent };